import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { PlgInviteApi } from '../plg-invite-api';
import { PsHttpService, type PatSnapCommonResponseData } from '@patsnap/tahiti-core/common/ps-http';

@injectable()
export class PlgInviteApiImpl extends PsHttpService implements PlgInviteApi {
    get options() {
        return {
            baseURL: `${import.meta.env.VITE_EUREKA_SERVICE_URI}/core-eurekals-api/eurekals_agent`,
        };
    }

    async bindUserWithInviter(): Promise<void> {
        return this.get<PatSnapCommonResponseData<void>>({
            url: 'user',
            params: {
                refresh_cache: true,
                check_first_login: true,
            },
        }).then(() => undefined);
    }
}
